

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import DateTools from '@/DateTools'
import CompleteToggle from '@/components/CardControls/CompleteToggle.vue'
import DetailsButton from '@/components/CardControls/DetailsButton.vue'
import DueDateButton from '@/components/CardControls/DueDateButton.vue'
import InlineCardLabels from '@/components/CardParts/InlineCardLabels.vue'
import { TrelloCard } from '@/TrelloClient'
import { uiConfig } from '@/config'

@Component({
    components: {
        CompleteToggle,
        DetailsButton,
        DueDateButton,
        InlineCardLabels,
    },
    props: {
        card: Object as PropType<TrelloCard>,
    },
})
export default class extends Vue {
    get showInlineLabels() {
        return uiConfig.showInlineLabels
    }
}
